<template>
  <v-navigation-drawer
    :value="openDrawer"
    width="1000"
    right
    absolute
    temporary
    @input="emitInputEvent"
  >
    <v-card elevation="0" id="profile">
      <v-card-title class="border-bottom mb-3"
        >Add Authorized Account</v-card-title
      >
    </v-card>
    <v-dialog v-model="dialog" persistent
      ><v-card>
        <v-card-title class="border-bottom mb-3">Profile</v-card-title
        ><v-card-text
          ><v-row>
            <h4 v-if="userToAddAuthUsersTo">
              Adding authorized accounts to record of
              <b>{{ userToAddAuthUsersTo.account_name }}</b>
            </h4>
            <h4 v-else>
              Authorize Accounts for
              <b>{{ loginDetails.username }}</b>
            </h4>
          </v-row>
          <v-row>
            <v-col cols="4">
              <v-text-field
                v-model="form.newDelegate"
                @keyup.enter="addDelegate"
              ></v-text-field>
              <v-checkbox
                v-model="form.delegate"
                :label="`Give Delegation Permission`"
              ></v-checkbox>
            </v-col>
            <v-col cols="2">
              <v-btn color="info" @click="addDelegate(userToAddAuthUsersTo)">
                Authorize Account
              </v-btn>
              <v-btn @click="clearuserToAddAuthUsersTo()">Cancel</v-btn>
            </v-col>
          </v-row></v-card-text
        ></v-card
      >
    </v-dialog>
    <v-dialog v-model="removeUserAccessDialog" persistent
      ><v-card>
        <v-card-title class="border-bottom mb-3">Profile</v-card-title
        ><v-card-text
          ><v-row>
            <h4>
              Remove authorizations from
              <b>{{ removeUserEventInfo.account_name }}</b>
            </h4>
          </v-row>
          <v-row>
            <v-col cols="4">
              <v-select
                :items="possibleUsersToRemove"
                v-model="removeUserForm.username"
                label="Choose An Account"
                outlined
              ></v-select>
            </v-col>
            <v-col cols="2">
              <v-btn color="info" @click="removeAuthorization(removeUserForm)">
                Remove Authorization
              </v-btn>
              <v-btn @click="closeDialog()">Cancel</v-btn>
            </v-col>
          </v-row></v-card-text
        ></v-card
      >
    </v-dialog>
    <v-dialog v-model="toggleDelegateDialog"
      ><v-card>
        <v-card-title class="border-bottom mb-3">Profile</v-card-title
        ><v-card-text
          ><v-row>
            <h4>
              Edit delegate status of
              <b>{{ removeUserEventInfo.account_name }}</b>
            </h4>
          </v-row>
          <v-row>
            <v-col cols="4">
              <v-select
                :items="possibleUsersToDelegateToggle"
                v-model="selectedUserToToggleDelegate"
                label="Choose An Account"
                outlined
                @change="getDelegateStatus($event)"
              ></v-select>
              <v-switch
                v-if="selectedUserToToggleDelegate"
                v-model="selectedUserToToggleDelegateStatus"
                :label="
                  `Delegate Status: ${selectedUserToToggleDelegateStatus}`
                "
                @change="toggleDelegateStatus()"
              ></v-switch>
            </v-col>
            <v-col cols="2">
              <v-btn @click="closeDialog()">Done</v-btn>
            </v-col>
          </v-row></v-card-text
        ></v-card
      >
    </v-dialog>
    <!-- <my-delegates :delegates="delegates" /> -->
    <MyUsersIAmAuthorizedOn
      @addAuthorizeUser="handleAddAuthorizedUser($event)"
      @removeUserAccess="handleRemoveUserAccess($event)"
      @opentoggledelegatemodal="handleToggleDelegateModal($event)"
      :users="recordsIamAuthorizedOn"
      :currentUser="userData"
      @reloadusers="refetchrecordsiamauthon()"
    />
  </v-navigation-drawer>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import MyDelegates from "./MyDelegates.vue";
import MyUsersIAmAuthorizedOn from "./UsersIAmAuthorizedOn.vue";
export default {
  props: { openDrawer: Boolean },
  components: { MyUsersIAmAuthorizedOn },
  computed: {
    ...mapState({
      recordsIamAuthorizedOn: state => state.app.recordsiamauthorizedon
    }),
    ...mapGetters({
      loginDetails: "getUser"
    }),
    possibleUsersToRemove: function() {
      const arr = [];
      if (this.removeUserEventInfo?.acls) {
        this.removeUserEventInfo.acls.forEach(user =>
          user.username != this.loginDetails.username
            ? arr.push(user.username)
            : ""
        );
      }
      return arr;
    },
    possibleUsersToDelegateToggle: function() {
      const arr = [];
      if (this.toggleDelegateEventInfo?.acls) {
        this.toggleDelegateEventInfo.acls.forEach(user =>
          user.username != this.loginDetails.username
            ? arr.push(user.username)
            : ""
        );
      }
      return arr;
    }
  },
  async created() {
    if (sessionStorage.getItem("userData")) {
      this.userData = await JSON.parse(sessionStorage.getItem("userData"));
      this.getAcls(this.userData.username);
      this.getRecordsIamAuthorizedon();
    }
  },
  data() {
    return {
      dialog: false,
      removeUserAccessDialog: false,
      toggleDelegateDialog: false,
      userData: {},
      userToAddAuthUsersTo: false,
      form: {
        newDelegate: "",
        delegate: false
      },
      removeUserEventInfo: {},
      removeUserForm: {
        username: ""
      },
      toggleDelegateEventInfo: undefined,
      selectedUserToToggleDelegate: undefined,
      selectedUserToToggleDelegateStatus: undefined,
      delegates: []
      // RecordsIamAuthorizedon: []
    };
  },
  methods: {
    addDelegate(item) {
      let addAclObj = {
        member: this.loginDetails.username,
        assignee: this.form.newDelegate,
        makeDelegate: this.form.delegate
      };
      if (item) {
        addAclObj.member = item.account_name;
      }
      this.$store
        .dispatch("addDelegate", addAclObj)
        .then(res => {
          this.getAcls(this.userData.username);
          this.getRecordsIamAuthorizedon();
          this.form.newDelegate = "";
          this.form.delegate = false;
          this.$store.dispatch("addNotification", {
            type: "success",
            message: JSON.stringify(res)
          });
          this.clearuserToAddAuthUsersTo();
        })
        .catch(err => {
          this.$store.dispatch("addNotification", {
            type: "error",
            message: JSON.stringify(err)
          });
          this.clearuserToAddAuthUsersTo();
        });
    },
    async getAcls(username) {
      let acls = await this.$store.dispatch("getMyAcls", username);
      this.delegates = acls.auth_users;
    },
    async getRecordsIamAuthorizedon() {
      let getRecordsIamAuthorizedon = await this.$store.dispatch(
        "getRecordsIAmAuthorizedOn"
      );
    },
    handleAddAuthorizedUser($event) {
      this.dialog = true;
      this.userToAddAuthUsersTo = $event;
    },
    closeDialog() {
      this.dialog = false;
      this.removeUserAccessDialog = false;
      this.toggleDelegateDialog = false;
    },
    clearuserToAddAuthUsersTo() {
      this.userToAddAuthUsersTo = false;
      this.dialog = false;
    },
    handleRemoveUserAccess($event) {
      this.removeUserEventInfo = $event;
      this.removeUserAccessDialog = true;
    },
    removeAuthorization(removeUserForm) {
      const revokeauthobj = {
        acct: this.loginDetails.username,
        user: removeUserForm.username
      };
      this.$store.dispatch("removeAuthOnUser", revokeauthobj).then(res => {
        this.getAcls(this.userData.username);
        this.getRecordsIamAuthorizedon();
        this.closeDialog();
      });
    },
    handleToggleDelegateModal($event) {
      this.toggleDelegateEventInfo = $event;
      this.toggleDelegateDialog = true;
    },
    getDelegateStatus($event) {
      this.toggleDelegateEventInfo.acls.forEach(user =>
        user.username === this.selectedUserToToggleDelegate
          ? (this.selectedUserToToggleDelegateStatus = user.delegate)
          : ""
      );
    },
    toggleDelegateStatus() {
      const delstatusobj = {
        acct: this.loginDetails.username,
        user: this.selectedUserToToggleDelegate,
        delegate: this.selectedUserToToggleDelegateStatus
      };

      this.$store.dispatch("changeDelegateStatus", delstatusobj);
    },
    emitInputEvent(e) {
      this.$emit("input", e);
    },
    refetchrecordsiamauthon() {
      this.getRecordsIamAuthorizedon();
    }
  }
};
</script>

<style>
.border-bottom {
  border-bottom: 1px solid #ccc;
}
</style>
